export default __webpack_public_path__ + "static/media/indicator-signup.d9de00f8.png";